import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-black text-[#C7A064] py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col items-center justify-center space-y-2">
          <Link 
            to="/legal-privacy" 
            className="text-xs font-montserrat font-semibold text-center leading-[176%] tracking-[0%] text-[#C7A064] hover:text-white transition-colors cursor-pointer"
          >
            Legal & Privacy
          </Link>
          <div className="text-xs font-montserrat font-normal text-center leading-[176%] tracking-[0%] text-[#C0C0C0]">
            @2025 Hair To Dye For Extension & Color Lounge, All Rights Reserved
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
